import { Component, OnInit } from '@angular/core';
import { AppliedPatchClientViewModel, AppliedPatchGroupViewModel, ArkUserType } from '../../core/api/models';
import { DeveloperApiService } from '../../core/api/services';
import { Utils } from '../../core/utils';
import { AuthService } from '../../main/auth.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-applied-patches-component',
  templateUrl: './applied-patches.component.html',
  standalone: false
})
export class AppliedPatchesComponent implements OnInit {
  public pageTitle = 'Applied Patches';

  public patchName = '';
  public dateFrom = '';
  public dateTo = '';
  public list: AppliedPatchGroupViewModel[] = [];
  public loadingList = false;

  public expandedRows: { [key: string]: boolean } = {};

  constructor(
    private authService: AuthService,
    private alertService: AlertService,
    private apiService: DeveloperApiService
  ) { }

  ngOnInit(): void {
    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

    const today = new Date();
    const last30Days = new Date(today);
    last30Days.setDate(today.getDate() - 30);

    this.dateFrom = this.formatDateInput(last30Days);
    this.dateTo = this.formatDateInput(today);

    this.loadTable();
  }

  loadTable(): void {
    this.loadingList = true;

    this.apiService
      .ListAppliedPatches({
        patchName: this.patchName || undefined,
        dateFrom: this.dateFrom || undefined,
        dateTo: this.dateTo || undefined
      })
      .forEach((result) => {
        this.list = result || [];
        this.expandedRows = {};
        this.loadingList = false;
      })
      .catch((err) => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loadingList = false;
      });
  }

  toggleRow(item: AppliedPatchGroupViewModel): void {
    const key = this.getGroupKey(item);
    this.expandedRows[key] = !this.expandedRows[key];
  }

  isRowExpanded(item: AppliedPatchGroupViewModel): boolean {
    return !!this.expandedRows[this.getGroupKey(item)];
  }

  runPatchForClient(item: AppliedPatchGroupViewModel, clientRow: AppliedPatchClientViewModel): void {
    if (!item?.Name || !clientRow?.ClientID) {
      this.alertService.error('Patch name or client ID is missing.');
      return;
    }

    const patchName = item.Name;
    const siteName = clientRow.SiteName || `Client #${clientRow.ClientID}`;

    this.alertService
      .confirm('Run Patch', `Run patch '${patchName}' for '${siteName}'?`)
      .forEach((confirmed) => {
        if (!confirmed) {
          return;
        }

        this.apiService
          .RunPatch({
            body: {
              clientId: clientRow.ClientID,
              patchName
            }
          })
          .forEach((result) => {
            this.alertService.success(result || `Patch '${patchName}' has been queued.`);
            this.loadTable();
          })
          .catch((err) => {
            this.alertService.error(Utils.getAjaxError(err));
          });
      });
  }

  getResultClass(hasErrors: boolean | null | undefined): string {
    return hasErrors ? 'bg-danger' : 'bg-success';
  }

  private getGroupKey(item: AppliedPatchGroupViewModel): string {
    return `${item.Name || ''}|${item.Description || ''}`;
  }

  private formatDateInput(value: Date): string {
    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
